module.exports = __webpack_public_path__ + "static/capitol-hill.191674aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capitol-hill.png
// module id = 281
// module chunks = 35783957827783 83016852698721 251955352258861